import { createContext, type ReactNode, useContext, useEffect } from "react";

export type CardReactionsContextValue = {
  register: (id: string) => void;
  render: (id: string) => ReactNode;
};

const CardReactionsContext = createContext<CardReactionsContextValue | null>(
  null,
);

export const CardReactionsProvider = CardReactionsContext.Provider;

export function useCardReactions(id?: string): ReactNode {
  const ctx = useContext(CardReactionsContext);

  useEffect(() => {
    if (ctx && id) ctx.register(id);
  }, [ctx, id]);

  if (!ctx || !id) return null;
  return ctx.render(id);
}
